import { RichTextFormatter, translate, translateFormatter } from '@/core/localization/translate';
export const {
  subscriptionLabel,
  subscriptionLabelWithSales,
  buttonLabel
} = translate({
  "subscriptionLabel": "Abonnement",
  "subscriptionLabelWithSales": "Promo",
  "buttonLabel": "D\xE9couvrir"
});
export const recruitmentTouchpointLabel = translateFormatter<{
  u: RichTextFormatter;
}>([{
  "type": 0,
  "value": "Livraison "
}, {
  "type": 8,
  "value": "u",
  "children": [{
    "type": 0,
    "value": "gratuite illimit\xE9e"
  }]
}, {
  "type": 0,
  "value": " \xE0 partir de 59\u20ACHT/mois"
}], undefined, undefined, "en");
export const recruitmentTouchpointLabelWithVariablePrice = translateFormatter<{
  u: RichTextFormatter;
  price: string;
}>([{
  "type": 0,
  "value": "Livraison "
}, {
  "type": 8,
  "value": "u",
  "children": [{
    "type": 0,
    "value": "gratuite illimit\xE9e"
  }]
}, {
  "type": 0,
  "value": " \xE0 partir de "
}, {
  "type": 1,
  "value": "price"
}, {
  "type": 0,
  "value": " HT/mois"
}], undefined, undefined, "en");